import styled from 'styled-components';

import ComponentButton from 'components/Button/ComponentButton';
import SubMenuGroup from 'components/Header/SubMenuGroup';
import useMenuData from 'components/Header/useMenuData';

import type { FC } from 'react';

type MobileMenuItemProps = {
  isOpen?: boolean;
  heading?: string;
  menu?: any[];
  openMenuGroup?: number;
  setIsMobileNavOpen?: () => void;
  setOpenMenu?: () => void;
};

const MobileMenuItem: FC<MobileMenuItemProps> = ({
  isOpen,
  heading,
  menu,
  openMenuGroup,
  setIsMobileNavOpen,
  setOpenMenu,
}) => {
  const submenu = useMenuData(menu);

  return (
    <Container
      className={`mobile-menu-item ${menu.heading.toLowerCase().replace(' ', '-')} ${isOpen ? 'active' : 'inactive'}`}
    >
      {submenu.map(subMenuItem =>
        subMenuItem.groups.map((item, index) => {
          const groupWithHeadings = { ...item, group: item.group || heading };

          return (
            <SubMenuGroup
              group={groupWithHeadings}
              openMenuGroup={openMenuGroup}
              businessType={subMenuItem.businessType}
              key={`submenu-group-${index}`}
              setIsMobileNavOpen={setIsMobileNavOpen}
              setOpenMenu={setOpenMenu}
            />
          );
        }),
      )}
      {submenu?.map(
        (subMenuItem, index) =>
          subMenuItem?.businessType &&
          openMenuGroup === index && (
            <ComponentButton
              link={
                subMenuItem?.businessType === 'Operations Suite'
                  ? '/operations-suite'
                  : subMenuItem?.businessType === 'Marketing Pro'
                  ? '/pro/marketing'
                  : '/pro/fleet'
              }
              buttonColor="Gray 900 Link"
              label="View All"
              key={`submenu-button-${index}`}
              className="!w-fit"
            />
          ),
      )}
    </Container>
  );
};

export default MobileMenuItem;

const Container = styled.div`
  height: 100%;

  &.inactive {
    animation: hideMenu 0.3s forwards;
    display: none;
  }

  &.active {
    display: flex;
  }

  .inactive {
    display: none;
  }

  .active {
    display: flex;
  }

  @keyframes hideMenu {
    0% {
      display: flex;
    }
    100% {
      display: none;
    }
  }

  .MuiButton-root {
    position: absolute;
    min-width: calc(100% - 50px);
    font-size: 14px;
    margin-top: 20px;
    bottom: 20px;
    border: 1px solid var(--Gray-400, #c1c2c3) !important;
  }
`;
